import { PARENT_MODULE_NAME } from '../constants';

import { MODULE_NAME } from './constants';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - TODO: Add proper state and payload types
export const selectShouldShowNextIntegrationDialog = (state: any) =>
  state.get(PARENT_MODULE_NAME)[MODULE_NAME].shouldShowDialog;
